/**
 * Wire shapes for /api/v2/admin/fast-appointments (cycle-27).
 *
 * BE wraps every read path through @app/common toSnake. detail
 * (GET /:id) hydrates notes: AppointmentHistory[] (DESC by created_at)
 * for the FE Timeline render. Mirrors the legacy
 * FAST_APPOINTMENT_FRAGMENT + the detail-only extras (note,
 * diagnosis, files, organization_info jsonb passthrough, links).
 */
import { Gender } from './users';

// Phase E Cycle 3 canonical (BE appointment.constants).
export enum FastAppointmentStatus {
  New = 'NEW',
  Replied = 'REPLIED',
  Rejected = 'REJECTED',
  Succeed = 'SUCCEED',
  Canceled = 'CANCELED',
  Pending = 'PENDING'
}

export interface FastAppointmentHistoryRow {
  id: number;
  status: FastAppointmentStatus;
  note: string | null;
  created_at: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}

export interface FastAppointmentListRow {
  id: number;
  first_name: string;
  last_name: string;
  email: string | null;
  user: number | null;
  phone: string | null;
  status: FastAppointmentStatus | null;
  date_of_birth: string | null;
  gender: Gender | null;
  organization_id: number | string | null;
  created_at: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}

export interface FastAppointmentDetail extends FastAppointmentListRow {
  diagnosis: string | null;
  files: string | null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  organization_info: any;
  links: string | null;
  note: string | null;
  notes: FastAppointmentHistoryRow[];
}

export interface FastAppointmentListResponse {
  results: FastAppointmentListRow[];
  total: number;
}

export interface FastAppointmentListQuery {
  page?: number;
  limit?: number;
  name?: string;
  status?: FastAppointmentStatus;
  organizationId?: number;
}

export interface UpdateFastAppointmentStatusInput {
  status: FastAppointmentStatus | 'WAITING_FOR_ARRIVAL';
  note?: string;
}
